import React from "react";
import { Box } from "@mui/material";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";
import { APP_TOKENS } from "./publicFormTokens";

/**
 * Legal copy shown above a signature, as one tinted block with the agreement's
 * name set bold at the head of the first paragraph.
 *
 * `paragraphs` is plain strings, not titled clauses: the wording is a legal
 * consent and isn't ours to restructure, so this component only decides how it
 * is presented.
 */
const DisclosureBox = ({ title, paragraphs = [] }) => (
  <Box
    sx={{
      background: APP_TOKENS.headerTint,
      border: `1px solid ${APP_TOKENS.border}`,
      borderRadius: APP_TOKENS.radius,
      p: 2.5,
    }}
  >
    <Flx column gap={1.25}>
      {paragraphs.map((paragraph, index) => (
        <Txt
          key={paragraph.slice(0, 40)}
          component="p"
          sx={{
            m: 0,
            fontSize: 12.5,
            lineHeight: 1.65,
            color: APP_TOKENS.inkMuted,
          }}
        >
          {/* The agreement's name leads the first paragraph inline rather than
              sitting on its own line — it reads as a legal document, not a
              stack of headed sections. */}
          {index === 0 && title && (
            <Box
              component="strong"
              sx={{ color: APP_TOKENS.ink, fontWeight: 700 }}
            >
              {`${title} `}
            </Box>
          )}
          {paragraph}
        </Txt>
      ))}
    </Flx>
  </Box>
);

export default DisclosureBox;
